import moment from 'moment';
import HelperMixin from '../../Shared/HelperMixin.vue';
import PaginationHelper from '../../Shared/PaginationHelper.vue';

// PR-12 — Audit log viewer for PricingConfig changes.
// The PricingChangeLog table is populated by PricingController on every
// PUT to /Configuration; this page reads it back via a GET that the
// backend does NOT yet expose. If the request 404s we surface a friendly
// notice so the operator knows the data exists but the endpoint is
// missing (rather than silently showing an empty table).

export default {
    name: 'PricingChangeLog',
    mixins: [HelperMixin],
    components: { PaginationHelper },

    filters: {
        moment(date) {
            if (!date) return '—';
            return moment(date).format('DD/MM/YYYY HH:mm');
        }
    },

    async created() {
        this.loginDetails = await this.CheckLoginStatus();
        if (!this.requireUserType([1])) return;
        await this.Load();
    },

    data() {
        return {
            Logs: [],
            From: '',
            To: '',
            UserId: '',
            pageNo: 1,
            pageSize: 20,
            totalCount: 0,
            MissingEndpoint: false,
        };
    },

    methods: {
        async Load(pageNo) {
            this.pageNo = pageNo || 1;
            this.$blockUI.Start();
            this.MissingEndpoint = false;

            const from = this.From ? this.ChangeDate(this.From) : '';
            const to = this.To ? this.ChangeDate(this.To) : '';

            try {
                const res = await this.$http.GetPricingChangeLog(
                    this.pageNo, this.pageSize, from, to, this.UserId
                );
                const data = res.data || {};
                this.Logs = data.items || data.logs || [];
                this.totalCount = data.total || data.count || this.Logs.length;
            } catch (e) {
                const code = e?.response?.status;
                if (code === 404 || code === 405) {
                    this.MissingEndpoint = true;
                    this.Logs = [];
                    this.totalCount = 0;
                } else {
                    this.Logs = [];
                    this.totalCount = 0;
                }
            } finally {
                this.$blockUI.Stop();
            }
        }
    }
};
